import type { AllRouteEndpoints } from "../routeTypes";

export const canvasBrief = "/:app_group_id/canvas_brief/:canvas_id";

export const canvasBriefCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/canvas_brief/:canvas_id"];

/**
 * The react-query key `useDashboardApiQuery` builds for the brief GET
 * (`[{ cacheKey, appGroupId }, ...params]`). Writers use it with
 * `queryClient.setQueryData` to publish a mutation response into the cache, so
 * readers see the fresh brief without waiting on a refetch (see
 * publishBriefResult in useBriefState).
 */
export const getCanvasBriefQueryKey = (appGroupId: string, canvasId: string) => [
  { cacheKey: canvasBrief, appGroupId },
  { appGroupId, canvasId },
];
